module.exports = __webpack_public_path__ + "static/media/gym.ee5ec57c.jpg";